"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = require("decentraland-ui/dist/components/Button/Button");
const Header_1 = require("decentraland-ui/dist/components/Header/Header");
const Modal_1 = require("decentraland-ui/dist/components/Modal/Modal");
const Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon/Icon"));
const useTrackContext_1 = __importDefault(require("../../context/Track/useTrackContext"));
const useFormatMessage_1 = __importDefault(require("../../hooks/useFormatMessage"));
const useShare_utils_1 = require("../../hooks/useShare.utils");
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
require("./ShareModal.css");
const handleShare = (e, url) => {
    e.preventDefault();
    const width = 600;
    const height = 350;
    const top = Math.ceil(window.outerHeight / 2 - height / 2);
    const left = Math.ceil(window.outerWidth / 2 - width / 2);
    window.open(url, 'targetWindow', `toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`);
};
exports.default = react_1.default.memo(function ShareModal({ data, ...props }) {
    const l = (0, useFormatMessage_1.default)();
    const track = (0, useTrackContext_1.default)();
    const mounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!mounted.current) {
            mounted.current = true;
        }
        else {
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!data) {
                track(useShare_utils_1.ShareEvent.SharePopupOpen);
            }
            else {
                track(useShare_utils_1.ShareEvent.SharePopupClose);
            }
        }
    }, [data]);
    const shareableText = (0, react_1.useMemo)(() => {
        if (data) {
            return data.text ? `${data.title} - ${data.text}` : data.title;
        }
        return '';
    }, [data]);
    const facebookLink = (0, react_1.useMemo)(() => encodeURI(l('@growth.ShareModal.uri.facebook', { url: data === null || data === void 0 ? void 0 : data.url })), [data]);
    const handleFacebookShare = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        track(useShare_utils_1.ShareEvent.ShareFallback, { data, social: 'facebook' });
        handleShare(e, facebookLink);
    }, [data, facebookLink, track]);
    const twitterLink = (0, react_1.useMemo)(() => encodeURI(l('@growth.ShareModal.uri.twitter', {
        url: data === null || data === void 0 ? void 0 : data.url,
        description: shareableText,
    })), [data, shareableText]);
    const handleTwitterShare = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        track(useShare_utils_1.ShareEvent.ShareFallback, { data, social: 'twitter' });
        handleShare(e, twitterLink);
    }, [data, twitterLink, track]);
    return (react_1.default.createElement(Modal_1.Modal, { ...props, className: TokenList_1.default.join(['share__modal', props.className]), open: !!data },
        react_1.default.createElement(Modal_1.Modal.Header, null,
            react_1.default.createElement(Header_1.Header, null, data === null || data === void 0 ? void 0 : data.title),
            react_1.default.createElement(Button_1.Button, { icon: true, onClick: props.onClose },
                react_1.default.createElement(Icon_1.default, { name: "close" }))),
        (data === null || data === void 0 ? void 0 : data.text) && react_1.default.createElement(Modal_1.Modal.Description, null, data === null || data === void 0 ? void 0 : data.text),
        react_1.default.createElement(Modal_1.Modal.Content, null,
            react_1.default.createElement("div", { className: "share-modal" },
                (data === null || data === void 0 ? void 0 : data.thumbnail) && (react_1.default.createElement("div", { className: "thumbnail", style: {
                        backgroundImage: data.thumbnail
                            ? `url("${data.thumbnail}")`
                            : '',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    } })),
                react_1.default.createElement("div", { className: "button-group" },
                    react_1.default.createElement(Button_1.Button, { as: "a", className: "button facebook", onClick: handleFacebookShare, href: facebookLink },
                        react_1.default.createElement(Icon_1.default, { name: "facebook f" }),
                        " ",
                        l(`@growth.ShareModal.share`)),
                    react_1.default.createElement(Button_1.Button, { as: "a", className: "button twitter", onClick: handleTwitterShare, href: twitterLink },
                        react_1.default.createElement(Icon_1.default, { name: "twitter" }),
                        " ",
                        l(`@growth.ShareModal.share`)))))));
});
